import React, { useEffect, useRef } from "react";

import "./styles.css";

import * as ReactIcons from "react-icons/fa";
import { logo } from "../../../assets/images";

const AboutUs = ({ closeModal }) => {
  //creating refs for different dropdowns
  const modalRef = useRef();

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  //click listener
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mdoal-container">
      <div className="modal-main" ref={modalRef}>
        <div className="modal-header-container">
          <p className="modal-header-text"> Welcome to Metro Home Services</p>
        </div>
        <div className="modal-container-main">
            <img src={logo}
            alt="MHS logo"
            style={{ width: "100%", height: "100%" }}>
            </img>
          <p>
             Metro Home Services is a new
            platform that makes homes beautiful, it is launched in 2023. It is
            the largest home services platform in India, Which helps the
            customer by booking the services like  Painting, Deep Cleaning,
            Plumbing, AC services, Electrical services and all kinds of home
            services. <br/><br/>If you are interested in any kind of services,
            please email us at support@metrohomeservices.in and we'll get in
            touch to help you with the services
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
